import React, { Component } from 'react'
import styles from './AcceptedForm.module.scss';
import classNames from 'classnames/bind';

import {Header, SubHeader, ContactUsText, AwairLogo} from '../../atoms';
import { acceptedFormContentsEn, acceptedFormContentsKr } from '../../../assets/contents/accepted-form';
import AppImage from '../../../assets/images/app-img.jpg';

const cx = classNames.bind(styles);

class AcceptedForm extends Component {
  render() {
    const {language} = this.props;
    const textContents = language === 'ko' ? acceptedFormContentsKr : acceptedFormContentsEn;
    const {
      header,
      headerDescription,
      contactUsDescription,
    } = textContents;
    return (
      <div>
        <AwairLogo />
        <div className={cx('AcceptedForm')}>
          <div className={cx('AcceptedForm__header-wrapper')}>
            <Header text={header} />
            <SubHeader text={headerDescription}/>
          </div>
          <img className={cx('AcceptedForm__app-image')} src={AppImage} alt="App" />
        </div>
        <ContactUsText className={cx('AcceptedForm__contact-us')} text={contactUsDescription} mailLink='hello@getawair.com'/>
      </div>
    )
  }
}

export default AcceptedForm;